import React from 'react'
import TitleBg from '../components/TitleBg'
import ExtendedWarrantyBg from '../images/ExtendedWarrantyBg.png';

function UsedCarTitle() {
  return (
    <>
    <TitleBg 
    title='Used Car Warranty explained '
    description="Before we start, let’s get back to basics. What exactly is a used car warranty? We understand that financial decisions like these require some careful consideration so you can make a decision with confidence. Here's everything you need to know about car warranties."
    bgImg={ExtendedWarrantyBg}
    />
    </>
  )
}

export default UsedCarTitle